// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3oJwQ","tab":"Tabs_tab__37Zrw","tabActive":"Tabs_tabActive__LBHIx"};